import { ExtraInformationType } from '@hb/domain/extra-information-type';
import { ApplicantsStoreService } from '@hb/modules/applicants/applicants-store.service';
import { ExtraInformationComponent } from '@hb/modules/global/tip/extra-information.component';
import { NextButtonComponent } from '@hb/modules';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';

import { ApContentModule } from '@ap/content';

@Component({
    selector: 'aow-info',
    templateUrl: './aow-info.component.html',
    standalone: true,
    imports: [ApContentModule, ReactiveFormsModule, AsyncPipe, ExtraInformationComponent, NextButtonComponent]
})
export class AowInfoComponent implements OnInit {
    protected readonly store = inject(ApplicantsStoreService);
    protected readonly textType = ExtraInformationType;

    mainApplicantAowWithin10years: boolean;
    coApplicantAowWithin10years = false;

    ngOnInit() {
        this.store.getMainApplicantDetails().subscribe((details) => (this.mainApplicantAowWithin10years = details?.aow10yr));
        this.store.getCoApplicantDetails().subscribe((details) => (this.coApplicantAowWithin10years = details?.aow10yr));
    }

    showForBothApplicants() {
        return this.mainApplicantAowWithin10years && this.coApplicantAowWithin10years;
    }

    showForMainApplicantOnly() {
        return this.mainApplicantAowWithin10years && !this.coApplicantAowWithin10years;
    }

    showForCoApplicantOnly() {
        return !this.mainApplicantAowWithin10years && this.coApplicantAowWithin10years;
    }

    nextQuestion(): void {
        this.store.setAowInfoFinished();
    }
}
